@if (canReport) {

  <!-- Le déclencheur est dans les navbars (BugReportLauncher) et le cadre de survol est posé par
       ElementPicker : rien ici ne recouvre la page hors de la popup. -->

  <!-- ── Popup de saisie ───────────────────────────────────────────────────── -->
  <app-popup
    [isOpen]="step() === 'editing' || step() === 'sent'"
    size="large"
    color="amarante"
    variant="secondary"
    [title]="'BUG_REPORT.TITLE' | translate"
    (closed)="close()">

    <div class="bug-report__dialog">
      @if (step() === 'editing') {

        <figure class="bug-report__preview">
          @if (screenshot.isCapturing()) {
            <span class="bug-report__preview-placeholder">{{ 'BUG_REPORT.CAPTURING' | translate }}</span>
          } @else if (screenshot.url()) {
            <img [src]="screenshot.url()" [alt]="'BUG_REPORT.SCREENSHOT_ALT' | translate" />
          } @else {
            <span class="bug-report__preview-placeholder">{{ 'BUG_REPORT.NO_SCREENSHOT' | translate }}</span>
          }
          @if (targetComponents()) {
            <figcaption class="bug-report__components">{{ targetComponents() }}</figcaption>
          }
        </figure>

        <label class="bug-report__label" for="bug-report-title">
          {{ 'BUG_REPORT.SUMMARY_LABEL' | translate }}
        </label>
        <input
          #titleInput
          id="bug-report-title"
          type="text"
          class="bug-report__input"
          data-testid="bug-report-title"
          required
          [maxlength]="maxTitleLength"
          [placeholder]="'BUG_REPORT.SUMMARY_PLACEHOLDER' | translate"
          [(ngModel)]="title" />

        <label class="bug-report__label" for="bug-report-description">
          {{ 'BUG_REPORT.DESCRIPTION_LABEL' | translate }}
        </label>
        <textarea
          id="bug-report-description"
          class="bug-report__textarea"
          data-testid="bug-report-description"
          required
          rows="5"
          [maxlength]="maxDescriptionLength"
          [placeholder]="'BUG_REPORT.DESCRIPTION_PLACEHOLDER' | translate"
          [(ngModel)]="description"></textarea>
        <span class="bug-report__counter">{{ description.length }} / {{ maxDescriptionLength }}</span>

        @if (error(); as failure) {
          <p class="bug-report__error" role="alert">{{ failure.key | translate: failure.params }}</p>
        }

      } @else if (result(); as ticket) {

        <p class="bug-report__success" role="status">
          {{ 'BUG_REPORT.SENT' | translate: { key: ticket.key } }}
        </p>
        <a #ticketLink class="bug-report__link" [href]="ticket.url" target="_blank" rel="noopener">
          {{ 'BUG_REPORT.OPEN_TICKET' | translate }}
        </a>
        @if (!ticket.screenshotAttached && screenshot.url()) {
          <p class="bug-report__warning">{{ 'BUG_REPORT.SCREENSHOT_NOT_ATTACHED' | translate }}</p>
        }
        @if (!ticket.movedToInitialStatus) {
          <p class="bug-report__warning">{{ 'BUG_REPORT.STATUS_NOT_SET' | translate }}</p>
        }
      }
    </div>

    <div slot="footer" class="bug-report__actions">
      @if (step() === 'editing') {
        <app-button
          variant="secondary"
          size="small"
          color="amarante"
          [state]="isSending() ? 'disabled' : 'default'"
          [label]="'BUTTONS.CANCEL' | translate"
          (clicked)="close()">
        </app-button>
        <app-button
          variant="secondary"
          size="small"
          color="amarante"
          [state]="isSending() ? 'disabled' : 'default'"
          [label]="'BUG_REPORT.RESELECT' | translate"
          (clicked)="reselect()">
        </app-button>
        <app-button
          variant="primary"
          size="small"
          color="amarante"
          data-testid="bug-report-send"
          [state]="canSend() ? 'default' : 'disabled'"
          [label]="(isSending() ? 'BUG_REPORT.SENDING' : 'BUG_REPORT.SEND') | translate"
          (clicked)="send()">
        </app-button>
      } @else {
        <app-button
          variant="primary"
          size="small"
          color="amarante"
          [label]="'BUTTONS.CLOSE' | translate"
          (clicked)="close()">
        </app-button>
      }
    </div>
  </app-popup>
}
